import {AppActions, RootState} from 'app/rootReducer'
import Toast from 'components/Basic/Toast'
import {Epic} from 'redux-observable'
import {concat, from, of} from 'rxjs'
import {
  catchError,
  filter,
  ignoreElements,
  mergeMap,
  switchMap,
  tap,
} from 'rxjs/operators'
import {AnalyticsService} from 'services/api'
import {getAnalyticsSearchQueryParams} from '../helpers'
import {analyticsOverviewActions} from './analyticsOverviewSlice'

const getOverviewEndpointsEpic: Epic<AppActions, AppActions, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(analyticsOverviewActions.getOverviewEndpoints.match),
    switchMap(() => {
      const searchInputs = state$?.value?.analyticsOverview?.searchInputs
      const params = getAnalyticsSearchQueryParams(searchInputs)
      return from(AnalyticsService.getOverviewEndpoints(params)).pipe(
        mergeMap(({data}) => [
          analyticsOverviewActions.getOverviewEndpointsSuccess(data),
        ]),
        catchError((message: string) =>
          concat(
            of(analyticsOverviewActions.getOverviewEndpointsFailure(message)),
          ),
        ),
      )
    }),
  )

const getOverviewEndpointsFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(analyticsOverviewActions.getOverviewEndpointsFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const getOverviewViolationsEpic: Epic<AppActions, AppActions, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(analyticsOverviewActions.getOverviewViolations.match),
    switchMap(() => {
      const searchInputs = state$?.value?.analyticsOverview?.searchInputs
      const params = getAnalyticsSearchQueryParams(searchInputs)
      return from(AnalyticsService.getOverviewViolations(params)).pipe(
        mergeMap(({data}) => [
          analyticsOverviewActions.getOverviewViolationsSuccess(data),
        ]),
        catchError((message: string) =>
          concat(
            of(analyticsOverviewActions.getOverviewViolationsFailure(message)),
          ),
        ),
      )
    }),
  )

const getOverviewViolationsFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(analyticsOverviewActions.getOverviewViolationsFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const getOverviewAnalyticsEpic: Epic<AppActions, AppActions, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(analyticsOverviewActions.getOverviewAnalytics.match),
    switchMap(() => {
      const searchInputs = state$?.value?.analyticsOverview?.searchInputs
      const params = getAnalyticsSearchQueryParams(searchInputs)
      return from(AnalyticsService.getOverviewAnalytics(params)).pipe(
        mergeMap(({data}) => [
          analyticsOverviewActions.getOverviewAnalyticsSuccess(data),
        ]),
        catchError((message: string) =>
          concat(
            of(analyticsOverviewActions.getOverviewAnalyticsFailure(message)),
          ),
        ),
      )
    }),
  )

const getOverviewAnalyticsFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(analyticsOverviewActions.getOverviewAnalyticsFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

export const analyticsOverviewEpics = [
  getOverviewEndpointsEpic,
  getOverviewEndpointsFailureEpic,
  getOverviewViolationsEpic,
  getOverviewViolationsFailureEpic,
  getOverviewAnalyticsEpic,
  getOverviewAnalyticsFailureEpic,
]
